import { InventoryTransferDetailsPage } from "./InventoryTransferDetailsPage";
export default InventoryTransferDetailsPage;
